module.exports = __webpack_public_path__ + "img/Twitter.cde4e920.svg";